import { v4 as uuidv4 } from "uuid"

import {
  BranchCase,
  CHECK_KIND_LEAF,
  CheckExpression,
  WorkflowNode
} from "lib/types/workflow"
import {
  ACTION,
  BRANCH,
  CONDITION,
  NODE_TYPE_ACTION,
  NODE_TYPE_BRANCH,
  NODE_TYPE_CONDITION
} from "../../nodeKind"

/** Empty PAYMENT_PROVIDER leaf used as the starting expression for any new
 *  condition / branch case — the editor prompts the user to add at least one
 *  field before the leaf becomes valid. */
const stubLeaf = (): CheckExpression => ({
  kind: CHECK_KIND_LEAF,
  check: { type: "PAYMENT_PROVIDER", fields: {} }
})

const stubCase = (label: string): BranchCase => ({
  id: uuidv4(),
  label,
  expression: stubLeaf()
})

export const createConditionNode = (): WorkflowNode => ({
  id: uuidv4(),
  type: CONDITION,
  position: { x: 0, y: 0 },
  data: {
    nodeType: NODE_TYPE_CONDITION,
    label: "New Condition",
    expression: stubLeaf()
  }
})

export const createActionNode = (): WorkflowNode => ({
  id: uuidv4(),
  type: ACTION,
  position: { x: 0, y: 0 },
  data: {
    nodeType: NODE_TYPE_ACTION,
    label: "New Action",
    actionType: "CANCELLATION"
  }
})

export const createBranchNode = (): WorkflowNode => ({
  id: uuidv4(),
  type: BRANCH,
  position: { x: 0, y: 0 },
  data: {
    nodeType: NODE_TYPE_BRANCH,
    label: "New Branch",
    cases: [stubCase("Case 1"), stubCase("Case 2")]
  }
})

/** Build a fresh, empty case suitable for appending via the canvas "+" button
 *  or the sidebar "Add case" action. Exported so both call sites stay
 *  consistent. */
export const createBranchCase = (label: string): BranchCase => stubCase(label)
